import React, { useState } from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { Row } from '../../../atoms/row/Row';
import StarRating from '../../shared/starRating/StarRating';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import LinkedInIcon from '../../../../../static/icons/linkedInIcon';
// import { Email } from '../../../../../static/icons/email';

const Comment = ({ text, author }) => (
  <div>
    <Typography as="span" textAlign="left">
      {text}
    </Typography>
    <Typography as="span" textAlign="left" className="italic">
      &nbsp; - {author}
    </Typography>
  </div>
);

const TagText = ({ id, tag, hasCenterDot = true }) => {
  if (!tag?.text) {
    return '';
  }

  return (
    <Typography key={`${id}-${tag.text}`} fontVariant="sm" textAlign="left">
      {tag.text}
      {hasCenterDot && <span className="mx-1">•</span>}
    </Typography>
  );
};

const TagTextIcon = ({ id, tag, hasCenterDot = true }) => {
  if (!tag?.icon || !tag?.text) {
    return '';
  }

  if (tag?.icon === 'LINKEDIN') {
    return (
      <>
        <LinkedInIcon color={'#0077B5'} size={18} />
        <Typography key={`${id}-${tag.text}`} fontVariant="sm" textAlign="left">
          {tag.text}
          {hasCenterDot && <span className="mx-1">•</span>}
        </Typography>
      </>
    );
  }

  /*
  if (tag?.icon === 'MAIL') {
    return (
      <>
        <Email size={18} color={'#2ed3b7'} />
        <Typography key={`${id}-${tag.text}`} fontVariant="sm" textAlign="left">
          {tag.text}
          {hasCenterDot && <span className="mx-1">•</span>}
        </Typography>
      </>
    );
  }
  */
};

const ReviewItem = ({ item, t }) => {
  const [showOriginalText, setShowOriginalText] = useState(false);

  const {
    id,
    title,
    translatedTitle,
    tags,
    questions,
    ratings,
    isTranslated,
    commentText,
    commentAuthor,
    translatedCommentText,
    translatedCommentAuthor,
  } = item;

  return (
    <div className="flex flex-col bg-white mx-8 rounded-[32px] px-5 py-8 md:p-10 lg:p-20 shadow-xl gap-6">
      <Stack className="">
        <Typography as="h3" fontVariant="h6" textAlign="left">
          {isTranslated && !showOriginalText ? translatedTitle : title}
        </Typography>
        <Row className="flex-wrap">
          {tags.map((tag, index) => {
            if (tag?.icon && tag?.text) {
              return (
                <div
                  key={`${id}-tag-${index}`}
                  className="flex items-center gap-2"
                >
                  <TagTextIcon
                    id={`${id}-text-icon`}
                    tag={tag}
                    hasCenterDot={index >= 0 && index < tags.length - 1}
                  />
                </div>
              );
            }

            return (
              <div
                key={`${id}-tag-${index}`}
                className="flex items-center gap-2"
              >
                <TagText
                  id={`${id}-text`}
                  tag={tag}
                  hasCenterDot={index >= 0 && index < tags.length - 1}
                />
              </div>
            );
          })}
        </Row>
      </Stack>
      <div className="flex flex-col md:flex-row gap-10">
        <Stack className="flex flex-1 md:flex-[0.5] gap-3">
          <Stack className="gap-2">
            {questions.map((question) => (
              <Stack key={`${id}-${question.question}`} className="gap-0 mb-3">
                <Typography
                  fontVariant="xs"
                  textAlign="left"
                  className="uppercase"
                >
                  {question.question}
                </Typography>
                <Typography
                  fontVariant="md"
                  textAlign="left"
                  className="font-medium"
                >
                  {isTranslated && !showOriginalText
                    ? question.translatedAnswer
                    : question.answer}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack className="flex flex-col flex-1 md:flex-[0.5] gap-4 md:gap-10">
          <Stack className="gap-2 flex-1">
            {ratings
              .filter((ratingItem) => ratingItem.rating !== '')
              .map((ratingItem) => (
                <Row
                  key={`${id}-${ratingItem.text}`}
                  className="justify-between items-center gap-2"
                >
                  <Typography
                    fontVariant="md"
                    textAlign="left"
                    className="w-fit font-medium "
                  >
                    {ratingItem.text}
                  </Typography>
                  <StarRating
                    width={25}
                    height={25}
                    rating={ratingItem.rating}
                  />
                </Row>
              ))}
          </Stack>
        </Stack>
      </div>

      {((commentText && commentAuthor) ||
        (translatedCommentText && translatedCommentAuthor)) && (
        <div className="flex flex-col">
          <Typography
            fontVariant="xs"
            textAlign="left"
            className="uppercase font-semibold"
          >
            {t('sp.reviewSystemOwnerComment')}
          </Typography>

          {(!isTranslated || showOriginalText) &&
            commentText &&
            commentAuthor && (
              <Comment text={commentText} author={commentAuthor} />
            )}

          {isTranslated &&
            !showOriginalText &&
            translatedCommentText &&
            translatedCommentAuthor && (
              <Comment
                text={translatedCommentText}
                author={translatedCommentAuthor}
              />
            )}
        </div>
      )}

      {isTranslated && (
        <div className="flex">
          <LinkButton
            label={
              showOriginalText
                ? t('common.back')
                : t('sp.reviewBtnShowOriginalLanguage')
            }
            variant="secondary-outlined"
            onClick={() => setShowOriginalText(!showOriginalText)}
          />
        </div>
      )}
    </div>
  );
};

export default ReviewItem;
